module.exports = __webpack_public_path__ + "img/avatar4.a5f9df5a.png";